import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAdmin({ children }) {
  const { loading, user, isAdmin } = useAuth();
  if (loading) return null;         // or a spinner
  if (!user || !isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}
